"use strict";

import Alert from "../../librairies/Alert";

export default class ClientsEdit {
  constructor($clientsEdit) {
    this.$clientsEdit = $clientsEdit;
    this.$directAccessLinkContainer = this.$clientsEdit.querySelector('#direct-access-link-container');
    this.$btnGeneratePassport = this.$clientsEdit.querySelector('button#passport-generator');
    this.$btnResetPassport = this.$clientsEdit.querySelector('button#passport-reset');

    this.bindEvents();
  }

  bindEvents() {
    if (this.$btnGeneratePassport) {
      this.$btnGeneratePassport.addEventListener('click', () => this.generatePassport());
    }

    if (this.$btnResetPassport) {
      this.$btnResetPassport.addEventListener('click', () => this.resetPassport());
    }
  }

  generatePassport() {
    fetch(window.location.origin + '/api/clients/passport/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client: this.$clientsEdit.querySelector('input[name="client_id"]').value
      })
    })
    .then(response => response.json())
    .then(response => {
      navigator.clipboard.writeText(response)
        .then(() => {
          if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
            Alert.success('Le lien a été copié dans votre presse-papiers.');
          } else {
            Alert.success('The link has been copied to your clipboard.');
          }
        })
        .catch(error => {
          if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
            Alert.warning('Une erreur est survenue lors de la copie du lien dans votre presse-papiers. Veuillez le copier manuellement.');
          } else {
            Alert.warning('An error occurred while copying the link to your clipboard. Please copy it manually.');
          }

          this.$directAccessLinkContainer.classList.remove("d-none");
          const link = document.createElement("p");
          link.textContent = response;
          this.$directAccessLinkContainer.appendChild(link);
        });
    })
    .catch(error => {
      if (localStorage.getItem('isDevMode') === '1') {
        console.error('Error:', error);
      }
    });
  }

  resetPassport() {
    this.$directAccessLinkContainer.innerHTML = '';
    this.$directAccessLinkContainer.classList.add("d-none");

    fetch(window.location.origin + '/api/clients/passport/reset/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client: this.$clientsEdit.querySelector('input[name="client_id"]').value
      })
    })
    .then(response => response.json())
    .then(hasReset => {
      if (hasReset) {
        if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
          Alert.success('Le lien d\'accès a été réinitialisé. Vous pouvez désormais le copier en cliquant sur le bouton adjacent à gauche.');
        } else {
          Alert.success('The access link has been reset. You can now copy it by clicking on the adjacent button to the left.');
        }
      } else {
        if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
          Alert.warning('Le lien d\'accès n\'a pas pu être réinitialisé. Veuillez réessayer ou contacter l\'équipe technique.');
        } else {
          Alert.warning('The access link could not be reset. Please try again or contact the technical team.');
        }
      }
    })
    .catch(error => {
      if (localStorage.getItem('isDevMode') === '1') {
        console.error('Error:', error);
      }
    })
  }
}
